/**
 * Responsive Images — rewrites inline content images to use ?w= for
 * Cloudflare Image Resizing via the Content Worker.
 *
 * Runs on images inside .gh-content (post/page body). Feature images
 * in templates already use ?w= via Handlebars (see card.hbs, post.hbs).
 *
 * For each <img> pointing to /content/...:
 * - Adds srcset with standard breakpoints
 * - Sets src to a reasonable default width
 * - Adds sizes attribute based on content container width
 */

const IMAGE_EXTENSIONS = /\.(jpg|jpeg|png|gif|webp|avif)(\?|$)/i;
const WIDTHS = [300, 600, 800, 1200, 1600, 2000];

export function initResponsiveImages() {
  const content = document.querySelector('.gh-content');
  if (!content) return;

  const images = content.querySelectorAll('img');

  for (const img of images) {
    const src = img.getAttribute('src');
    if (!src) continue;

    // Only process /content/ images (R2-served via Content Worker)
    if (!src.includes('/content/')) continue;

    // Skip if already has ?w= (already processed or template-generated)
    if (src.includes('?w=')) continue;

    // Skip SVGs — they don't benefit from resizing
    if (src.endsWith('.svg')) continue;

    // Skip GIFs — CF Image Resizing strips animation (only keeps first frame)
    if (/\.gif(\?|$)/i.test(src)) continue;

    // Skip non-image extensions
    if (!IMAGE_EXTENSIONS.test(src)) continue;

    // Strip any existing query params for clean base URL
    const baseUrl = src.split('?')[0];

    // Build srcset
    const srcset = WIDTHS.map(w => `${baseUrl}?w=${w} ${w}w`).join(', ');

    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', '(max-width: 900px) 100vw, (max-width: 1280px) 80vw, 1100px');

    // Set src to a reasonable default (1200px matches typical content width)
    img.setAttribute('src', `${baseUrl}?w=1200`);
  }
}
